<template>
  <div id="page-payment-finished">
    <vx-card
      v-if="orderStatus === 100"
      :title="$t('PaymentFinished.PaymentSuccessHeading')"
      title-color="#fff"
      card-background="success"
      content-color="#fff"
    >
      <p class="mb-3">
        {{ $t("PaymentFinished.PaymentSuccessText") }}
      </p>
      <p class="mb-3">
        {{ $t("PaymentFinished.PaymentSuccessFooter") }}
      </p>
      <p class="mb-3">{{ $t("PaymentFinished.InvoiceMessage") }}</p>
    </vx-card>
    <vx-card
      v-if="orderStatus >= 0 && orderStatus < 100 "
      :title="$t('PaymentFinished.PaymentPendingHeading')"
      title-color="#fff"
      card-background="primary"
      content-color="#fff"
    >
      <p class="mb-3">
        {{ $t("PaymentFinished.PaymentPendingText") }}
      </p>
      <p class="mb-3">
        {{ $t("PaymentFinished.PaymentPendingFooter") }}
      </p>
    </vx-card>
    <vx-card
      v-if="orderStatus < 0"
      :title="$t('PaymentFinished.PaymentCancelledHeading')"
      title-color="#fff"
      card-background="danger"
      content-color="#fff"
    >
      <p class="mb-3">
        {{ $t("PaymentFinished.PaymentCancelledText") }}
      </p>
      <p class="mb-3">
        {{ $t("PaymentFinished.PaymentCancelledFooter") }}
      </p>
    </vx-card>
  </div>
</template>

<script>

export default {
  data () {
    return {
      orderStatus: -1
    }
  },
  components: {
  },
  created () {
    const x = this.$route.query.orderStatusId
    if (x) {
      this.orderStatus = Math.trunc(x)
    }
  }
}

</script>
